<template>
  <div style="display: flex">
    <el-config-provider
      :value-on-clear="null"
      :empty-values="[undefined, null]"
    >
      <el-select
        v-model="state.withholding_agent_type"
        class="c-withholdingagent-search-select"
        @change="
          delete state.withholding_agent_arr;
          state.showWithholdingAgent = false;
          onCallBack();
        "
      >
        <el-option label="扣缴义务人" :value="0" />
        <el-option label="供应商" :value="1" />
      </el-select>
    </el-config-provider>
    <div
      class="c-withholdingagent-search-groupbox"
      @click="state.showWithholdingAgent = true"
    >
      <li style="flex: 1; display: flex; column-gap: 5px">
        <template v-if="state.withholding_agent_arr?.length > 0">
          <div
            class="c-withholdingagent-search-tag"
            style="max-width: 200px; overflow: hidden; text-overflow: ellipsis"
          >
            {{ state.withholding_agent_arr[0]?.name }}
          </div>
          <el-popover
            v-if="state.withholding_agent_arr?.length > 1"
            placement="right"
            width="auto"
            popper-style="max-height: 90vh;overflow-y: auto;"
          >
            <template #reference>
              <div class="c-withholdingagent-search-tag" @click.stop="">
                {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
              </div>
            </template>
            <template #default>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  row-gap: 5px;
                  width: fit-content;
                "
              >
                <ul
                  v-for="(item, index) in state.withholding_agent_arr"
                  :key="item"
                  style="
                    white-space: nowrap;
                    background-color: #f0f2f5;
                    color: var(--el-color-info);
                    border-radius: 4px;
                    font-size: 12px;
                    padding: 0 9px;
                    height: 24px;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                    column-gap: 10px;
                  "
                >
                  <li>{{ item.name }}</li>
                  <el-icon
                    @click.stop="
                      state.withholding_agent_arr.splice(index, 1);
                      onCallBack();
                    "
                    color="#a2a2a2"
                    style="cursor: pointer"
                    ><CircleClose
                  /></el-icon>
                </ul>
              </div>
            </template>
          </el-popover>
        </template>
        <text v-else style="color: #a2a2a2">
          {{
            "点击选择" +
            (state.withholding_agent_type === 1 ? "供应商" : "扣缴义务人")
          }}
        </text>
      </li>
      <el-icon
        v-if="state.withholding_agent_arr?.length > 0"
        @click.stop="
          delete state.withholding_agent_arr;
          onCallBack();
        "
        color="#a2a2a2"
        ><CircleClose
      /></el-icon>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showWithholdingAgent && state.withholding_agent_type === 0"
      title="选择扣缴义务人"
      @close="state.showWithholdingAgent = false"
    >
      <c_WithholdingAgentSelect
        @close="onConfirm"
        :selectItems="state.withholding_agent_arr"
      ></c_WithholdingAgentSelect>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showWithholdingAgent && state.withholding_agent_type === 1"
      title="选择供应商"
      @close="state.showWithholdingAgent = false"
    >
      <c_SupplierSelect
        @close="onConfirm"
        :selectItems="state.withholding_agent_arr"
      ></c_SupplierSelect>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {});

    const onConfirm = (arr) => {
      state.withholding_agent_arr = arr;
      state.showWithholdingAgent = false;
      onCallBack();
    };

    const onCallBack = () => {
      emit("confirm", {
        type: state.withholding_agent_type,
        ids: state.withholding_agent_arr?.map((m) => m.id).join(","),
      });
    };
    return { state, onConfirm, onCallBack };
  },
};
</script>
<style scoped></style>
